/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DriveDataSummary
 */
export interface DriveDataSummary {
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    driveTime: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    engineOnTime: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    avgSpeed: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    cntTakeoff: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    brakeDistance: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    cruiseControlTime: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    cruiseControlPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    avgRaising: number;
    /**
     * 
     * @type {number}
     * @memberof DriveDataSummary
     */
    distance: number;
}

export function DriveDataSummaryFromJSON(json: any): DriveDataSummary {
    return DriveDataSummaryFromJSONTyped(json, false);
}

export function DriveDataSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriveDataSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driveTime': json['drive_time'],
        'engineOnTime': json['engine_on_time'],
        'avgSpeed': json['avg_speed'],
        'cntTakeoff': json['cnt_takeoff'],
        'brakeDistance': json['brake_distance'],
        'cruiseControlTime': json['cruise_control_time'],
        'cruiseControlPercentage': json['cruise_control_percentage'],
        'avgRaising': json['avg_raising'],
        'distance': json['distance'],
    };
}

export function DriveDataSummaryToJSON(value?: DriveDataSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drive_time': value.driveTime,
        'engine_on_time': value.engineOnTime,
        'avg_speed': value.avgSpeed,
        'cnt_takeoff': value.cntTakeoff,
        'brake_distance': value.brakeDistance,
        'cruise_control_time': value.cruiseControlTime,
        'cruise_control_percentage': value.cruiseControlPercentage,
        'avg_raising': value.avgRaising,
        'distance': value.distance,
    };
}


